import { render, staticRenderFns } from "./FacetsCurrentRefinements.vue?vue&type=template&id=bbca085a"
import script from "./FacetsCurrentRefinements.vue?vue&type=script&setup=true&lang=js"
export * from "./FacetsCurrentRefinements.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports